import axiosInstance from './axiosConfig';
import { CustomQuoteRequest, CustomQuoteResponse } from "../models/customQuote";

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

export const customQuoteService = {
  createQuote: async (formData: FormData): Promise<CustomQuoteResponse> => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('No authentication token found');
      } 

      const response = await axiosInstance.post(`${API_URL}/customQuote`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${token}`
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getQuotes: async (): Promise<CustomQuoteResponse> => {
    try {
      const token = localStorage.getItem('token');

      console.log("token",token)
      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axiosInstance.get(`${API_URL}/customQuote`, {
        headers: {
          'Authorization': `Bearer ${token}`
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}; 